import { Indicator } from '../../../Common/Charts/Indicator';
import { useAttentionChartsDataContext } from './hooks/useAttentionChartsDataContext';

export const PregnantWomen6PrenatalConsultations1To12Weeks = () => {
    const { chartData } = useAttentionChartsDataContext();

    return (
        <Indicator
            title={
                'Indice DE Gestantes com pelo menos 6 Consultas Pré-Natal entre 1 e 12 Semanas'
            }
            indicatorValue={
                chartData?.indicators
                    ?.pregnantWomen6PrenatalConsultations1To12Weeks
            }
            className="aligned-container"
            goalValue={45}
            goalMessage="Meta Aceitável - acima de 45%"
        />
    );
};
